var React = require('react');

function DoubleshapeInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Groupe_405","data-name":"Groupe 405","transform":"translate(-1200.133 -119.133)"},[React.createElement("rect",{"id":"Rectangle_72","data-name":"Rectangle 72","width":"708","height":"324","rx":"162","transform":"translate(1200.133 719.765) rotate(-45)","fill":"#fff","opacity":"0.111","key":0}),React.createElement("rect",{"id":"Rectangle_73","data-name":"Rectangle 73","width":"708","height":"324","rx":"162","transform":"translate(1458.133 619.765) rotate(-45)","fill":"#fff","opacity":"0.076","key":1})]));
}

DoubleshapeInline.defaultProps = {"width":"987.734","height":"829.734","viewBox":"0 0 987.734 829.734"};

module.exports = DoubleshapeInline;

DoubleshapeInline.default = DoubleshapeInline;
